import { type FC, type ReactNode } from "react";

import { Label, TextBox, Value } from "./engagementFunnelTooltip.styles";

interface FunnelLabeledMetricProps {
    label: string;
    children?: ReactNode;
}

export const FunnelLabeledMetric: FC<FunnelLabeledMetricProps> = ({ label, children }) => (
    <TextBox>
        <Label>{label}</Label>
        <Value>{children}</Value>
    </TextBox>
);
